export default __webpack_public_path__ + "images/0d0c266cb75d93760432ae2335830723.svg";